module.exports = __webpack_public_path__ + "static/img/RW454-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW454-G_1.png
// module id = aNJR
// module chunks = 0